(function(){function replaceText(root){if(!root)return;if(root.nodeType===3){if(root.nodeValue&&root.nodeValue.indexOf('1874')>-1)root.nodeValue=root.nodeValue.replace(/1874/g,'1972');return;}if(root.nodeType!==1&&root.nodeType!==9&&root.nodeType!==11)return;if(root.nodeType===1&&(root.tagName==='SCRIPT'||root.tagName==='STYLE'||root.tagName==='TEXTAREA'))return;var walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);var node;while(node=walker.nextNode()){if(node.parentElement&&(node.parentElement.closest('script,style,textarea')))continue;if(node.nodeValue&&node.nodeValue.indexOf('1874')>-1)node.nodeValue=node.nodeValue.replace(/1874/g,'1972');}}function start(){replaceText(document.body);var observer=new MutationObserver(function(mutations){mutations.forEach(function(m){if(m.type==='characterData')replaceText(m.target);m.addedNodes&&m.addedNodes.forEach(replaceText);});});observer.observe(document.body,{subtree:true,childList:true,characterData:true});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();})();

(function () {
  var loadingPromise;

  function getDrawer() {
    return document.querySelector('#t4s-menu-drawer');
  }

  function hasMenu(drawer) {
    return Boolean(drawer && drawer.querySelector('#menu-mb__ul'));
  }

  function installMenu(markup) {
    var drawer = getDrawer();
    if (!drawer || hasMenu(drawer)) return;

    var parsed = new DOMParser().parseFromString(markup, 'text/html');
    var section = parsed.querySelector('#shopify-section-mb_nav');
    if (!section) return;

    drawer.querySelectorAll('.t4s-skeleton-element').forEach(function (node) {
      node.remove();
    });

    if (!hasMenu(drawer)) {
      drawer.insertAdjacentHTML('beforeend', section.outerHTML);
      drawer.classList.add('is-la-menu-loaded');
    }
  }

  function loadMenu() {
    var drawer = getDrawer();
    if (!drawer || hasMenu(drawer)) return Promise.resolve();
    if (loadingPromise) return loadingPromise;

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    loadingPromise = fetch(root + '?section_id=mb_nav', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Mobile menu request failed');
        return response.text();
      })
      .then(installMenu)
      .catch(function () {})
      .finally(function () {
        loadingPromise = null;
      });

    return loadingPromise;
  }

  function start() {
    loadMenu();

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-menu-drawer]')) return;
      loadMenu();
      window.setTimeout(loadMenu, 350);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
